import { ensure } from '@/common/utils'

// During build time, environment variables might not be available
// This is safe for static generation as the value will be properly set at runtime
export const cognitoClientId = process.env['NEXT_PUBLIC_AWS_COGNITO_CLIENT_ID']
  ? ensure(process.env['NEXT_PUBLIC_AWS_COGNITO_CLIENT_ID'])
  : 'build-time-placeholder'

export const envName = process.env['NEXT_PUBLIC_ENV_NAME']

export const apiUrl = process.env['NEXT_PUBLIC_API_URL'] || 'http://localhost:8000'

// TODO: 本番環境ではバックエンドからワンタイムトークンを取得する形に置換予定
export const showcanStsUrl = process.env['NEXT_PUBLIC_SHOWCAN_STS_URL'] || ''
// TODO: 本番環境ではバックエンドからワンタイムトークンを取得する形に置換予定
export const showcanStsApiKey = process.env['NEXT_PUBLIC_SHOWCAN_STS_API_KEY'] || ''
